// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__3KNwm","inner":"Form_inner__3QEKR","range":"Form_range__PoUTh","name":"Form_name__3qPU1","actions":"Form_actions__2WmWh"};